import { removeUnifiedError } from '../../partnerCentralUtils';
import { BaseAuthenticatorSession, isOTPValid, } from './'
let S = com.ts.mobile.sdk;

export default class CustomOtpAuthenticatorSession extends BaseAuthenticatorSession {
  constructor(title, username, possibleTargets, autoExecedTarget, helper) {
    super(title, username, helper);

    this.OtpAuthenticationState = {};
    this.OtpAuthenticationState["TargetSelection"] = 0;
    this.OtpAuthenticationState["CodeInvalidated"] = 1;
    this.OtpAuthenticationState["AuthenticatorInput"] = 2;

    this.possibleTargets = possibleTargets;
    this.autoExecedTarget = autoExecedTarget;
    this.state = autoExecedTarget
      ? this.OtpAuthenticationState.AuthenticatorInput
      : this.OtpAuthenticationState.TargetSelection;
  }

  setAvailableTargets(targets) {
    this.possibleTargets = targets;
  }
  setGeneratedOtp(format, target) {
    this.generatedFormat = format;
    this.generatedForTarget = target;
    if (!target) {
      this.state = this.OtpAuthenticationState.TargetSelection;
    } else {
      this.state = this.OtpAuthenticationState.AuthenticatorInput;
    }
  }

  promiseOtpInput() {

    const isMFALogin = document.getElementById('sign-in-container')
    if (isMFALogin) {
      document.querySelector("#sign-in-container").className =
        "show-enter-otp";
      return new Promise((resolve, reject) => {
        let submitButton = document.getElementById("otp-submit-button");
        submitButton.onclick = () => {
          removeUnifiedError()
          let otp = document.getElementById("otp").value;
          if (isOTPValid()) {
            const rememberMeState = document.querySelector("#remember-me-check")?.getAttribute("state") // the state of the checkbox is a string ex: 'true', 'false'
            const rememberMe = Boolean(rememberMeState === "true")  // converting "true"/"false" to a boolean value
            this.clientContext["rememberme"] = rememberMe;
            let input = com.ts.mobile.sdk.OtpInputOtpSubmission.createOtpSubmission(
              otp.toString()
            );
            let inputTargetBased =
              com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(
                input
              );

            resolve(
              com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(
                inputTargetBased
              )
            );
          }
        };

        const cancelButtonArr = Array.from(document.querySelectorAll("#dt-back-button, #mb-enter-otp-back-button"))
        cancelButtonArr.forEach(cancelButton => {

          cancelButton.onclick = () => {
            resolve(S.InputOrControlResponse.createControlResponse(
              S.ControlRequest.create(S.ControlRequestType.AbortAuthentication)
            ))
            document.querySelector("#sign-in-container").className = "show-provide-email-password"
              document.querySelector("#history-back-button").classList.remove("hidden")

          }
        })

        let resendButton = document.getElementById("otp-resend-button");
        resendButton.onclick = () => {
          let resend =
            com.ts.mobile.sdk.OtpInputRequestResend.createOtpResendRequest();
          let inputTargetBased =
            com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(
              resend
            );
          resolve(
            com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(
              inputTargetBased
            )
          );
        };
      });
    }

    else {
      document.querySelector('#otp-input').classList.remove('hidden')
      document.querySelector('#password-help').classList.add('hidden')

      return new Promise((resolve, reject) => {
        const fpjOTPSubmitButton = document.getElementById("otp-submit-button");
        fpjOTPSubmitButton.onclick = () => {
          let otp = document.getElementById("otp").value;
          if (isOTPValid()) {
            let rememberMe = false;
            this.clientContext["rememberme"] = rememberMe;

            let input = com.ts.mobile.sdk.OtpInputOtpSubmission.createOtpSubmission(
              otp.toString()
            );
            let inputTargetBased =
              com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(
                input
              );

            resolve(
              com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(
                inputTargetBased
              )
            );
          }
        };

        let resendButton = document.getElementById("otp-resend-button");
        resendButton.onclick = () => {
          let resend =
            com.ts.mobile.sdk.OtpInputRequestResend.createOtpResendRequest();
          let inputTargetBased =
            com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(
              resend
            );
          resolve(
            com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(
              inputTargetBased
            )
          );
        };
      })
    }


  }

  promiseTargetSelectionInput() {

    let menuItems = this.possibleTargets.map((target) => {
      return {
        title: target.getChannel() + " - " + target.getDescription(),
        value: S.InputOrControlResponse.createInputResponse(
          S.TargetBasedAuthenticatorInput.createTargetSelectionRequest(target)
        ),
      };
    });
    /*
      Sets possible targets to session storage and fires event to be used by 
    */
    sessionStorage.setItem("targetData", JSON.stringify(this.possibleTargets));
    window.dispatchEvent(new Event("storage"))
    const signInContainer = document.querySelector("#sign-in-container")
    if (signInContainer) {
      signInContainer.className = "show-email-cta"
      document.querySelector("#history-back-button").className = "hidden"
    }


    const cancelRequest = S.InputOrControlResponse.createControlResponse(
      S.ControlRequest.create(S.ControlRequestType.AbortAuthentication)
    );
    return super.helper().presentSelectionUI(menuItems, "Please choose an OTP Target", cancelRequest, this.clientContext);

  }

  promiseAuthInput() {
    switch (this.state) {
      case this.OtpAuthenticationState.TargetSelection:
        return this.promiseTargetSelectionInput();
      case this.OtpAuthenticationState.CodeInvalidated:
        return this.promiseTargetSelectionInput();
      case this.OtpAuthenticationState.AuthenticatorInput:
        return this.promiseOtpInput();
    }
  }
  promiseRegInput() {
    return Promise.reject("Otp registration unsupported");
  }
}
